module.exports = __webpack_public_path__ + "static/media/2.986d4dda.jpg";